import styled from 'styled-components';
import { COLORS } from 'src/constants/colors';

export const GenreStyled = styled.ul`
    display: flex;
    gap: 5px;
`;

export const ItemStyled = styled.li`
    color: ${COLORS.Blue};
    font-size: 12px;
`;
